import { api } from './api';

/** What a redeemed code paid out, plus the new INCPT balance (`incpt`) or
 *  Liquid staking principal (`liquid_usdt`). */
export interface RedeemResult {
  code: string;
  amount: string;
  rewardKind: 'incpt' | 'liquid_usdt';
  balance: string;
}

export const redeemPromocode = (initData: string, code: string) =>
  api<RedeemResult>(initData, '/v1/promocodes/redeem', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });

/** A card issue discount code priced for one template. Nothing is spent yet. */
export interface CardPromoPreview {
  code: string;
  discountPercent: number;
  issueFeeUsd: number;
  discountedFeeUsd: number;
}

export const previewCardPromo = (
  initData: string,
  code: string,
  templateId: number,
  depositAmount?: number,
) =>
  api<CardPromoPreview>(initData, '/v1/promocodes/preview-card', {
    method: 'POST',
    body: JSON.stringify({
      code,
      template_id: templateId,
      ...(depositAmount != null ? { deposit_amount: depositAmount } : {}),
    }),
  });

export const releaseCardPromo = (initData: string, code: string) =>
  api<{ released: boolean }>(initData, '/v1/promocodes/release-card', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });

/** Map a thrown redeem error to a friendly message. */
export function promocodeErrorMessage(
  raw: string,
  t: (k: string, o?: Record<string, unknown>) => string,
  fallback: string,
): string {
  if (raw.includes('code_used')) return t('promo.errUsed');
  if (raw.includes('limit_exceeded')) return t('promo.errLimit');
  if (raw.includes('wrong_kind')) return t('promo.errWrongKind');
  // 'no such code' and 'malformed' read the same, so guessing learns nothing.
  if (raw.includes('code_invalid') || raw.includes('404')) return t('promo.errInvalid');
  if (raw.includes('429')) return t('promo.errTooMany');
  return fallback;
}
